import { render, staticRenderFns } from "./feedTable.vue?vue&type=template&id=1fbb2c07&class=feed-table&"
import script from "./feedTable.vue?vue&type=script&lang=js&"
export * from "./feedTable.vue?vue&type=script&lang=js&"
import style0 from "./feedTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports